import { Component, Input } from '@angular/core';

@Component({
	selector: 'ahp-dashboard-no-payments',
	templateUrl: './dashboard-no-payments.component.html',
	styleUrls: ['./dashboard-no-payments.component.scss'],
})
export class DashboardNoPaymentsComponent {
	/**
	 * the merchant locale suffix
	 */
	@Input() merchantLocaleSuffix: string;
	constructor() {}
}
